exports.components = {
  "component---src-pages-e-ticket-jsx": () => import("./../../../src/pages/e-ticket.jsx" /* webpackChunkName: "component---src-pages-e-ticket-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

